import * as React from 'react';
import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';
import { IconWithLabel, Button, media } from '@packages/ui';

const BurgerButtonStyled = styled(Button)<SpaceProps>`
  flex-shrink: 0;
  ${media.from.lg`
    display: none;
  `}
  ${space}
`;

export const BurgerButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (props) => (
  <BurgerButtonStyled variant="clean" data-testid="mobile-menu-button" {...props}>
    <IconWithLabel icon="menu">Menu</IconWithLabel>
  </BurgerButtonStyled>
);
